// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","736":"vendor"}[chunkId] + "." + {"532":"271591d992c152b6432d","736":"7f8c5f6bc15c7a16cd18"}[chunkId] + ".css";
};